import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Component } from 'react';
import { connect } from 'react-redux';

import DOM from './ordersCustomer';

import {
    handleBasicGridviewMount,
    handleBasicGridviewPagination,
} from '../../../core/utils/helpers';

import * as customerActions from '../../../core/customer/customerActions';

class OrdersCustomer extends Component {
    constructor(props) {
        super(props);
        this.view = DOM;
    }

    componentDidMount() {
        const { actions, customerId } = this.props;
        handleBasicGridviewMount(actions.getCustomerOrdersRequest, 'searchCustomerOrders', { id: customerId });
    }

    componentWillUnmount() {
        // Reset orders
        const { actions } = this.props;
        if (actions && actions.resetCustomerOrders) {
            actions.resetCustomerOrders();
        }
    }

    handlePagination = (page, pageSize) => {
        const { actions } = this.props;
        handleBasicGridviewPagination(actions.getCustomerOrdersRequest, 'searchCustomerOrders', page, pageSize);
    }

    render() {
        return this.view();
    }
}

OrdersCustomer.propTypes = {
    actions: PropTypes.object.isRequired,
    customerId: PropTypes.number.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        orders: state.customer.orders.rows,
        total: state.customer.orders.total,
        page: state.customer.orders.page,
        isFetching: state.customer.isFetching,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...customerActions
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrdersCustomer);
